/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/cohorting.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Cohorting
 */
export interface Cohorting {
    /**
     * @generated from protobuf field: string experiment_name = 1;
     */
    experiment_name: string;
    /**
     * @generated from protobuf field: string experiment_group = 2;
     */
    experiment_group: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Cohorting$Type extends MessageType<Cohorting> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Cohorting", [
            { no: 1, name: "experiment_name", kind: "scalar", localName: "experiment_name", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "name of the experiment", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Flag name" } },
            { no: 2, name: "experiment_group", kind: "scalar", localName: "experiment_group", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "test, control, excluded", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Flag value" } }
        ]);
    }
    create(value?: PartialMessage<Cohorting>): Cohorting {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.experiment_name = "";
        message.experiment_group = "";
        if (value !== undefined)
            reflectionMergePartial<Cohorting>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Cohorting): Cohorting {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string experiment_name */ 1:
                    message.experiment_name = reader.string();
                    break;
                case /* string experiment_group */ 2:
                    message.experiment_group = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Cohorting, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string experiment_name = 1; */
        if (message.experiment_name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.experiment_name);
        /* string experiment_group = 2; */
        if (message.experiment_group !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.experiment_group);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Cohorting
 */
export const Cohorting = new Cohorting$Type();
